<template>
    <form>
        <dx-validation-group :ref="`validationGroup`">
            <rd-popup-content>
                <div class="row">
                    <rd-column :size="$columns.TwelveOnLg">
                        <rd-form-group :label="$t('add.label.departmentName')">
                            <dx-select-box :search-enabled="true"
                                           :data-source="getPzzDepartments"
                                           display-expr="Text"
                                           value-expr="Value"
                                           v-model="DepartmentId">
                                <dx-validator>
                                    <dx-required-rule :message="$t('fieldRules.reuiredShort')" />
                                    <DxAsyncRule :validation-callback="validateLimit" :message="$t('validation.department')" />
                                </dx-validator>
                            </dx-select-box>
                        </rd-form-group>
                    </rd-column>
                    <rd-column :size="$columns.TwelveOnLg">
                        <rd-form-group :label="$t('add.label.monthFrom')">
                            <dx-date-box picker-type="calendar"
                                         :calendar-options="{ maxZoomLevel: 'year' }"
                                         v-model="MonthFrom"
                                         :min="now"
                                         :value.sync="startValue"
                                         :max.sync="endValue"
                                         displayFormat="monthAndYear"
                                         date-serialization-format="yyyy-MM-dd">
                                <dx-validator>
                                    <dx-required-rule :message="$t('fieldRules.reuiredShort')" />
                                    <DxAsyncRule :validation-callback="validateLimit" :message="$t('validation.month')" />
                                </dx-validator>
                            </dx-date-box>
                        </rd-form-group>
                    </rd-column>
                    <rd-column :size="$columns.TwelveOnLg">
                        <rd-form-group :label="$t('add.label.monthTo')">
                            <dx-date-box picker-type="calendar"
                                         :calendar-options="{ maxZoomLevel: 'year' }"
                                         v-model="MonthTo"
                                         :value.sync="endValue"
                                         :min.sync="startValue"
                                         displayFormat="monthAndYear"
                                         date-serialization-format="yyyy-MM-dd">
                                <dx-validator>
                                    <dx-required-rule :message="$t('fieldRules.reuiredShort')" />
                                    <DxAsyncRule :validation-callback="validateLimit" :message="$t('validation.month')" />
                                </dx-validator>
                            </dx-date-box>
                        </rd-form-group>
                    </rd-column>
                    <rd-column :size="$columns.TwelveOnLg">
                        <rd-form-group :label="$t('add.label.limit')">
                            <dx-number-box v-model="Limit">
                                <dx-validator>
                                    <dx-required-rule :message="$t('fieldRules.reuiredShort')" />
                                </dx-validator>
                            </dx-number-box>
                        </rd-form-group>
                    </rd-column>
                </div>
            </rd-popup-content>
            <rd-popup-actions>
                <dx-button :use-submit-behavior="false"
                           styling-mode="text"
                           type="normal"
                           :text="$t('buttons.cancel')"
                           @click="closePopup">
                </dx-button>
                <dx-button :use-submit-behavior="true"
                           type="default"
                           class="ml-1"
                           :text="$t('buttons.save')"
                           @click="closePopupOnSave">
                </dx-button>
            </rd-popup-actions>
        </dx-validation-group>
    </form>
</template>

<script>
    // @ is an alias to /src
    import { DxNumberBox } from 'devextreme-vue/number-box';
    import DxDateBox from 'devextreme-vue/date-box';
    import DxSelectBox from 'devextreme-vue/select-box';
    import DxButton from 'devextreme-vue/button';
    import {
        DxRequiredRule,
        DxAsyncRule,
        DxValidator
    } from 'devextreme-vue/validator';
    import DxValidationGroup from 'devextreme-vue/validation-group';

    import { mapGetters, mapActions, mapMutations } from 'vuex';
    import { mapFields } from 'vuex-map-fields';
    import commonMessages from '../../locales';
    import localMessages from '../locales';
    const name = "administrationStores/dictionariesStores/pzzDepartmentMonthLimitsStores/addStore";

    export default {
        name: 'pzzDepartmentMonthLimitsAdd',
        data() {
            return {
                pageSizes: [5, 10, 15],
                now: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1),
                startValue: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1),
                endValue: new Date(new Date().getFullYear()+6, new Date().getMonth(), 1),
            }
        },
        computed: {
            ...mapGetters(name, ['getForm','getPzzDepartments']),
            ...mapFields(name, [
                'addForm.Limit',
                'addForm.MonthFrom',
                'addForm.MonthTo',
                'addForm.DepartmentId',
            ]),
        },
        methods: {
            ...mapActions(name, ['setDetails','setPzzDepartments', 'validateLimit', 'addLimit']),
            ...mapMutations(name, ['resetForm']),
            closePopup: function () {
                this.$emit('closeAdd');
                this.resetForm();
            },
            closePopupOnSave: function (e) {
                let validateResult = e.validationGroup.validate()
                if (validateResult.isValid) {
                    this.$emit('closeAdd');
                    this.addLimit();
                }
            }
        },
        mounted() {
            this.$refs["validationGroup"].instance.validate();
            this.setDetails();
            this.setPzzDepartments();
        },
        components: {
            DxDateBox,
            DxNumberBox,
            DxButton,
            DxValidator,
            DxRequiredRule,
            DxValidationGroup,
            DxAsyncRule,
            DxSelectBox
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages
        }
    }
</script>
